<template>
  <div class="expense-categories-component card-shape" :class="{ selected: selected }">

    <!-- Event category select -->
    <div
      class="form-field-container expense-checkbox"
      data-action="expenseTarget"
    >
      <div class="checkboxes">
        <div
          class="checkbox"
          @click="onCheck"
          :data-action="`check-expense-${expense.categoryRef.humanReadableId}`"
        >
          <input type="checkbox" :checked="selected" />
          <span class="form-checkbox" />
          <span>{{ expense.categoryRef.name }}</span>
        </div>
      </div>
    </div>

    <!-- Expense description -->
    <div
      v-if="organizationDetails.grantRequestAmountEnabled"
      class="form-field-container expense-details-container"
    >
      <div v-html="expense.categoryRef.descriptionHtml"></div>
    </div>

    <!-- Expense amount -->
    <div
      v-if="organizationDetails.grantRequestAmountEnabled && selected"
      class="form-field-container expense-amount-container"
    >
      <h4 class="form-field-header" v-translate>Amount requested</h4>
      <div class="form-field-container expense-amount">
        <md-field class="amount-input form-field-text">
          <div class="ExpenseCategory__USD">
            <span class="ExpenseCategory__USD__text">US$</span>
          </div>
          <md-input
            v-model="expense.amount"
            type="number"
            @input="onEnterAmount"
            @blur="$emit('fieldBlur')"
            :data-action="`input-expense-${expense.categoryRef.humanReadableId}-amount`"
            required
          ></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ExpenseComponent',
  props: {
    expense: {
      type: Object,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['currentRequest', 'organizationDetails']),
  },
  methods: {
    onCheck() {
      if (this.selected) {
        this.$emit('expense-unselected', this.expense)
      } else {
        this.$emit('expense-selected', this.expense)
      }
    },
    onEnterAmount() {
      this.$emit('amount-updated', this.expense)
    },
  },
}
</script>

<style lang="scss" scoped>
.md-field .md-input {
  border-bottom: 0;
}

.amount-input {
  padding: 0.75rem;
  margin-bottom: 0;
}

.expense-categories-component {
  &.selected {
    border: 2px solid black;
  }

  .form-field {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-field-container {
    margin-top: 0;

    &.expense-amount {
      margin-top: 0.5rem;
      max-width: 396px;

      .form-field-text {
        background-color: #dedfe1;
        border-bottom: 2px solid black;
      }
    }
  }

  .checkbox span.form-checkbox + span {
    font-family: 'SFPro-Regular';
    font-weight: bold;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

  .expense-details-container,
  .expense-amount-container {
    margin-top: 0.75rem;
    margin-left: 2.5rem;
    padding-left: 1px;
  }

  .expense-details-container {
    ::v-deep p {
      margin-bottom: 0;
    }
  }

  .expense-amount-container {
    margin-top: 1.5rem;
  }

  .ExpenseCategory__USD {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-right: 8px;
  }

  .ExpenseCategory__USD__text {
    font-style: italic;
  }
}
</style>
